screenSharePresenter.controller('screenSharePresenterCtrl', [
    '$rootScope',
    '$scope',
    '$timeout',
    '$window',
    'logService',
    'screenShareService',
    'attendeeService',
    'contentService',
    'vertoService',
    'helperService',
    'analyticsWrapperService',
    'attendeeListService',
    'meetingService',
    'annotationService',
    'supportLinkService',
    'notificationService',
    'localizationService',
    'brandingService',
    'executionEnvironmentEnum',
    'onboardingService',
    function (
        $rootScope,
        $scope,
        $timeout,
        $window,
        logService,
        screenShareService,
        attendeeService,
        contentService,
        vertoService,
        helperService,
        analyticsWrapperService,
        attendeeListService,
        meetingService,
        annotationService,
        supportLinkService,
        notificationService,
        localizationService,
        brandingService,
        executionEnvironmentEnum,
        onboardingService
    ) {
        var self = this;

        self.email = attendeeService.getEmail();
        self.attendantId = attendeeService.getAttendantId();
        self.isConnected = false; // client has regular screen content share (publish) enabled
        self.isScreenVideo = false; // client has screen video enabled (see multishare user pair)
        self.start = start;
        self.stop = stop;

        self.checkAndStartScreenShare = checkAndStartScreenShare;

        self.localStream = null;
        self.idle = false;
        self.controlHovered = false;
        self.startIdleTimeout = startIdleTimeout;
        self.stopIdleTimeout = stopIdleTimeout;
        self.resetIdleTimeout = resetIdleTimeout;
        self.startControlHover = startControlHover;
        self.stopControlHover = stopControlHover;
        self.cleanup = cleanup;

        self.shouldShowDisableAnnotation = shouldShowDisableAnnotation;
        self.hasAnnotationFeature = hasAnnotationFeature;
        self.canHostAnnotation = canHostAnnotation;
        self.disableAnnotation = disableAnnotation;
        self.enableAnnotation = enableAnnotation;
        self.isWebinar = meetingService.isWebinar;
        self.shouldShowPlaceHolder = shouldShowPlaceHolder;
        self.getAnnotationUnavailHelpLink = getAnnotationUnavailHelpLink;
        self.orderByHostsOnTopThenAlpha = orderByHostsOnTopThenAlpha;
        self.getAnnotationControlButtonClass = getAnnotationControlButtonClass;
        self.getAnnotationControlTooltip = getAnnotationControlTooltip;
        self.isSharingAppScreen = isSharingAppScreen;
        self.showScreenshareStopped = showScreenshareStopped;

        self.isCompactModeAvailable = meetingService.getCompactModeAvailable();
        self.enableCompactMode = enableCompactMode;
        self.VDIRef = helperService.getVDIRef();
        self.getCompactModeButtonToolTip = getCompactModeButtonToolTip;

        $scope.contentService = contentService;

        $scope.$on('sfu-screenshare-stream-started', onSfuScreenShareStreamStarted);

        $scope.$on('screenshare-started', function (e) {
            if (self.attendantId === contentService.getContentOwner() && !contentService.getIsFilePlay()) {
                self.isConnected = true;
                contentService.setIsLocalContentShared(self.isConnected, self.isScreenVideo);

                if (!meetingService.getIsSfuEnabled()) {
                    var screenShareStream = vertoService.getScreenShareLocalFeed();
                    if (screenShareStream) {
                        self.localStream = screenShareStream;
                    }
                }

                // videoroomCtrl will send back sfu-screenshare-stream-started, if needed, to set localStream - see ANYAM-14590
                $rootScope.$broadcast('sfu-screenshare-presenter-started');

                digest();

                $window
                    .$('#enable-annotation-btn-win7-placeholder')
                    .popover({ trigger: 'manual', html: true, animation: false })
                    .on('mouseenter', function () {
                        var _this = this;
                        $(this).popover('show');
                        $('.popover').on('mouseleave', function () {
                            $(_this).popover('hide');
                        });
                    })
                    .on('mouseleave', function () {
                        var _this = this;
                        $timeout(function () {
                            if (!$('.popover:hover').length) {
                                $(_this).popover('hide');
                            }
                        }, 300);
                    });
            }
        });

        $scope.$on('screenshare-ended', function () {
            self.cleanup();
        });

        // videoroom controller has updated this client's screen video status.
        $scope.$on('sfu-screen-video-state', function (e, data) {
            if (data && data.value) {
                self.isScreenVideo = true;
                contentService.setIsLocalContentShared(self.isConnected, self.isScreenVideo);
                $rootScope.$broadcast('sfu-screenshare-presenter-started'); // so that videoroom controller can retrun the stream
                digest();
            } else {
                self.isScreenVideo = false;
                contentService.setIsLocalContentShared(self.isConnected, self.isScreenVideo);
                self.localStream = null;
                digest();
            }
        });

        $scope.$on('start-screenshare', function (e, attendantId) {
            if (!contentService.getIsFilePlay()) {
                self.start();
            }
        });

        $scope.$on('stop-screenshare', function (e, requesterId) {
            if (self.attendantId === contentService.getContentOwner() || self.isScreenVideo) {
                if (self.attendantId !== requesterId) {
                    logService.log(
                        'Another client has requested to end the screenshare:',
                        requesterId,
                        'stopping now...'
                    );
                }

                // show alert that screen share stopped due to recording.
                if (self.isScreenVideo && requesterId === 'recording') {
                    self.showScreenshareStopped();
                }

                self.stop();
            }
        });

        $scope.$on('start-screenshare-verto-call', onStartScreenShareVertoCall);
        $scope.$on('screenshare-failed-to-start', onScreenShareFailedToStart);
        $scope.$on('content-cleanup', cleanup);
        $scope.$on('content-status', onContentStatus);

        ////////////////////////

        //Starts the screenshare dialogue window
        function start() {
            if (meetingService.getIsSfuEnabled() && !helperService.isElectron()) {
                //SFU screenshare starts from videoroomCtrl.js
                return;
            }

            //Electron should still call this if in SFU mode
            screenShareService.startScreenShare(self.email);
        }

        function stop(stoppedFromScreenShareCoverBtn) {
            if (stoppedFromScreenShareCoverBtn) {
                logService.log('Stop ScreenShare button clicked from ScreenShare cover... stopping now');
            }

            if (meetingService.getIsSfuEnabled()) {
                $rootScope.$broadcast('stop-sfu-screenshare');
            } else {
                screenShareService.stopScreenShare();
            }
        }

        //Called after user selects window to share
        function onStartScreenShareVertoCall() {
            screenShareService.startScreenShareVertoCall();
        }

        function resetIdleTimeout() {
            self.stopIdleTimeout();
            self.startIdleTimeout();
        }

        function stopIdleTimeout() {
            if (!self.isConnected) {
                return;
            }

            $timeout.cancel(self.idleTimeout);
            self.idle = false;
        }

        function shouldShowPlaceHolder() {
            var result = true;
            result = result && !self.canHostAnnotation();
            result = result && annotationService.getHasBasicAeroTheme();
            result = result && !self.isWebinar();
            return result;
        }

        function getAnnotationUnavailHelpLink() {
            return supportLinkService.getSupportLink('aeroIssue');
        }

        function startIdleTimeout() {
            if (!self.isConnected) {
                return;
            }

            self.idleTimeout = $timeout(function () {
                self.idle = true;
            }, 3000);
        }

        function startControlHover() {
            self.controlHovered = true;
            self.stopIdleTimeout();
        }

        function stopControlHover() {
            self.controlHovered = false;
            self.startIdleTimeout();
        }

        function onScreenShareFailedToStart() {
            var swalOptions;

            if (helperService.getIsRedesign() === true) {
                var closeButtonHtml =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                swalOptions = {
                    title:
                        closeButtonHtml +
                        'There was a problem sharing your screen, most likely due to your firewall settings.',
                    text: "We've made some adjustments on this end and we're pretty sure it'll work this time.  Lets try again!",
                    showCancelButton: true,
                    cancelButtonText: 'Nevermind',
                    showConfirmButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: 'Try Screen Sharing Again',
                    allowOutsideClick: false,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg',
                    customClass: 'screen-share-failed-to-start-modal'
                };
            } else {
                //TODO: REMOVE POST-REDESIGN
                swalOptions = {
                    title: 'There was a problem sharing your screen, most likely due to your firewall settings.',
                    text: "We've made some adjustments on this end and we're pretty sure it'll work this time.  Lets try again!",
                    type: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Never mind',
                    showConfirmButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: 'Try Screen Sharing Again',
                    allowOutsideClick: false
                };
            }
            $window.swal(swalOptions, function (retryCall) {
                if (retryCall) {
                    logService.log('Retrying screen share with all iceTransports');
                    screenShareService.startScreenShare(self.email);
                } else {
                    logService.log('User canceled screen sharing');
                }
            });
        }

        function cleanup() {
            if (!self.isScreenVideo) {
                // do not clear if still sharing screen video
                self.localStream = null;
            }
            self.isConnected = false;
            contentService.setIsLocalContentShared(self.isConnected, self.isScreenVideo);
            digest();
        }

        function checkAndStartScreenShare() {
            //Disable this function if content already initiating
            if (contentService.isContentInitiating()) {
                return;
            }

            analyticsWrapperService.eventTrack('ScreenShare Meeting - Clicked Screenshare button');

            if (!screenShareService.getExtensionInstalled()) {
                screenShareService.showInstallationPrompt(self.email);
                logService.log('ScreenShare Meeting - ScreenShare button clicked - Showing Installation Prompt');
                return;
            }

            if (!contentService.isContentPlaying()) {
                //No content playing, allow screenshare
                self.start();
                logService.log('ScreenShare Meeting - ScreenShare button clicked - Starting Screenshare');
            } else {
                if (contentService.getContentOwner() !== self.attendantId) {
                    //If you are not the owner, show override prompt
                    contentService.promptUserOverride('screenshare');
                    logService.log(
                        "ScreenShare button clicked - Calling promptUserOverride to override another user's content"
                    );
                } else if (contentService.getContentType() !== 'screenshare') {
                    //If you are the owner, but the current content is not screenshare, show override prompt
                    contentService.promptUserOverride('screenshare');
                    logService.log(
                        "ScreenShare button clicked - Calling promptUserOverride to override user's own content"
                    );
                }
            }
        }

        function orderByHostsOnTopThenAlpha(attendee) {
            //Pins self to top, then orders alphabetically for everyone else
            if (attendee.attendeeType === 'host') {
                return 1 + attendee.screenName;
            } else if (attendee.attendeeType === 'presenter') {
                return 2 + attendee.screenName;
            } else {
                return 3 + attendee.screenName;
            }
        }

        function hasAnnotationFeature() {
            return helperService.isElectron() && !self.isScreenVideo && annotationService.getIsAnnotationEnabled();
        }

        function canHostAnnotation() {
            return (
                !self.isScreenVideo &&
                annotationService.getIsAnnotationEnabled() &&
                annotationService.getCanHostAnnotation()
            );
        }

        function shouldShowDisableAnnotation() {
            return !annotationService.getIsSuspended() && !contentService.getIsSharingAppScreen();
        }

        function disableAnnotation() {
            annotationService.suspendAnnotation();
            analyticsWrapperService.eventTrack(
                'Meeting - Annotation - Screen sharer disables annotation (for all attendees)',
                {
                    category: 'Annotation',
                    attendee: attendeeService.getEmail()
                }
            );
        }

        function enableAnnotation() {
            annotationService.continueAnnotation();
            analyticsWrapperService.eventTrack(
                'Meeting - Annotation - Screen sharer re-enables annotation (for all attendees)',
                {
                    category: 'Annotation',
                    attendee: attendeeService.getEmail()
                }
            );
        }

        function getAnnotationControlTooltip() {
            var tooltip = '';
            if (contentService.getIsSharingAppScreen()) {
                tooltip = localizationService.translate(
                    'ANNOTATION.PRESENTER_SCREENSHARE_TOOLTIP.APP_SHARING_ANNOTATION_DISABLED'
                );
            }
            return tooltip;
        }

        function getAnnotationControlButtonClass() {
            var classes = [];

            if (contentService.getIsSharingAppScreen()) {
                classes.push('disabled');
            }

            return classes.join(' ');
        }

        function onContentStatus(e, data) {
            //This cleanup is for an edge case in which
            //server's content owner has changed but the client did not update
            //(due to server disconnectivity)
            if (self.isConnected && self.attendantId !== data.ownerID) {
                self.cleanup();
            }
        }

        function onSfuScreenShareStreamStarted(e, data) {
            if (data && data.stream) {
                logService.log('SFU local screenshare stream received by screenSharePresenterCtrl');
                self.localStream = data.stream;
                if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix) {
                    $timeout(function () {
                        if ($window.Janus?.hideVideo && $window.Janus?.getModalsOpenInVdiCount() === 0) {
                            // VDI - Re-toggle visibility of PIP video stream once screenshare starts.
                            $window.Janus.hideVideo(true, { pipVideoOnly: true });
                            $timeout(function () {
                                $window.Janus.hideVideo(false, { pipVideoOnly: true });
                            }, 50);
                        }
                    }, 1000);
                }
                digest();
            }
        }

        function isSharingAppScreen() {
            return contentService.getIsSharingAppScreen();
        }

        function showScreenshareStopped() {
            if (helperService.getIsRedesign()) {
                var closeButtonHtml =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                swalOptions = {
                    title: closeButtonHtml,
                    text: localizationService.translate('SCREENSHARE.DIALOG.STOPPED_DUE_TO_RECORDING'),
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OKAY_TEXT'),
                    allowOutsideClick: true,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-warning.svg',
                    customClass: 'screen-share-failed-to-start-modal'
                };
                $window.swal(swalOptions);
            }
        }

        function enableCompactMode() {
            if (onboardingService.isAppCuesModalOpen()) {
                return;
            }

            analyticsWrapperService.eventTrack('Meeting - User Selected Compact Mode Layout From Screenshare Overlay', {
                category: 'Header menu'
            });
            $rootScope.$broadcast('enable-compact-mode', true);
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function getCompactModeButtonToolTip() {
            return localizationService.translate('HEADER.TOGGLE_LAYOUT.TOOLTIP.ENABLE_COMPACT_MODE');
        }
    }
]);
